import { useEffect } from "react";
import InputField from "../../../components/InputField";
import SelectField from "../../../components/SelectField";
import Toggle from "../../../components/Toggle";

export default function PretStep({ data, errors, update }) {
  const pret = Number(data.pretVanzare) || 0;
  const valuta = data.valuta || "RON";
  const pjImplicat = data.vanzatorPJ || data.cumparatorPJ;
  const plafonNumerar = pjImplicat ? 5000 : 10000;
  const eRON = data.valuta === "RON";
  const eNumerar = data.modalitatePlata === "numerar";
  const eMixt = data.modalitatePlata === "numerar + transfer";
  const depasestePlafon = eNumerar && eRON && pret > plafonNumerar;
  const sumaNumerar = Number(data.sumaNumerar) || 0;
  const depasesteNumararMixt = eMixt && sumaNumerar > plafonNumerar;

  useEffect(() => {
    if (!eRON && data.modalitatePlata === "numerar") {
      update("modalitatePlata")({ target: { value: "transfer bancar" } });
    }
  }, [data.valuta]);

  const optiuniPlata = [
    { value: "transfer bancar", label: "Transfer bancar" },
    ...(eRON ? [{ value: "numerar", label: "Numerar (sub plafon legal)" }] : []),
    { value: "numerar + transfer", label: "Numerar + Transfer bancar" },
  ];

  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
      <InputField label="Pret vanzare" value={data.pretVanzare} onChange={update("pretVanzare")} placeholder="ex: 5000" type="number" required half error={errors.pretVanzare} />
      <SelectField
        label="Valuta"
        value={data.valuta}
        onChange={update("valuta")}
        options={[
          { value: "RON", label: "RON" },
          { value: "EUR", label: "EUR" },
          { value: "USD", label: "USD" },
        ]}
        half
      />
      <SelectField
        label="Modalitate de plata"
        value={data.modalitatePlata}
        onChange={update("modalitatePlata")}
        options={optiuniPlata}
        error={errors.modalitatePlata}
      />
      {depasestePlafon && (
        <div style={{
          flex: "1 1 100%",
          padding: "12px 16px",
          backgroundColor: "#fff3f0",
          border: "1px solid #e8a99a",
          borderRadius: "8px",
          fontSize: "13px",
          color: "#a84832",
          lineHeight: 1.6,
        }}>
          Plata in numerar depaseste plafonul legal de <strong>{plafonNumerar.toLocaleString("ro-RO")} RON</strong> ({pjImplicat ? "persoana juridica implicata" : "intre persoane fizice"}).
          {' Selecteaza "Transfer bancar" sau "Numerar + Transfer bancar".'}
        </div>
      )}
      {eMixt && (
        <>
          <InputField
            label={`Suma numerar in RON (max ${plafonNumerar.toLocaleString("ro-RO")})`}
            value={data.sumaNumerar}
            onChange={update("sumaNumerar")}
            placeholder="ex: 5000"
            type="number"
            required
            half
            max={plafonNumerar}
            error={errors.sumaNumerar}
          />
          <InputField
            label={`Suma transfer bancar (${valuta})`}
            value={eRON && pret > 0 && sumaNumerar > 0 ? String(pret - sumaNumerar) : ""}
            onChange={() => {}}
            placeholder={eRON ? "se calculeaza automat" : `restul din ${pret > 0 ? pret.toLocaleString("ro-RO") : "___"} ${valuta}`}
            type="number"
            half
            disabled
          />
          {depasesteNumararMixt && (
            <div style={{
              flex: "1 1 100%",
              padding: "12px 16px",
              backgroundColor: "#fff3f0",
              border: "1px solid #e8a99a",
              borderRadius: "8px",
              fontSize: "13px",
              color: "#a84832",
              lineHeight: 1.6,
            }}>
              Suma in numerar depaseste plafonul legal de <strong>{plafonNumerar.toLocaleString("ro-RO")} RON</strong>.
            </div>
          )}
        </>
      )}
      <InputField label="Data vanzarii" value={data.dataVanzare} onChange={update("dataVanzare")} type="date" required half error={errors.dataVanzare} />
      <Toggle label="Pret achitat integral la semnare" description="Pretul a fost achitat in totalitate la momentul semnarii contractului" checked={!!data.pretAchitatLaSemnare} onChange={() => update("pretAchitatLaSemnare")(!data.pretAchitatLaSemnare)} />
    </div>
  );
}
